/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Create_Choose_Type_DescriptionInputs */

const en_clients_create_choose_type_description = /** @type {(inputs: Clients_Create_Choose_Type_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose person (CPF) or company (CNPJ) to open the right form.`)
};

const pt_br2_clients_create_choose_type_description = /** @type {(inputs: Clients_Create_Choose_Type_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolha pessoa (CPF) ou empresa (CNPJ) para abrir o formulário correto.`)
};

/**
* | output |
* | --- |
* | "Choose person (CPF) or company (CNPJ) to open the right form." |
*
* @param {Clients_Create_Choose_Type_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_create_choose_type_description = /** @type {((inputs?: Clients_Create_Choose_Type_DescriptionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Create_Choose_Type_DescriptionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_create_choose_type_description(inputs)
	return pt_br2_clients_create_choose_type_description(inputs)
});